import { Modal } from 'antd';
import React from 'react';
import ActivityConnectedForm from './ActivityConnectedForm';

type Props = {
  id?: string;
  timesheetId?: string;
  showModal: boolean;
  close: () => void;
  onSave?: () => void;
};

class ActivityModalForm extends React.Component<Props> {
  render(): React.ReactElement {
    if (!this.props.showModal || !this.props.id || !this.props.timesheetId) {
      return <></>;
    }
    return (
      (<Modal open={this.props.showModal} onCancel={this.props.close} footer={null}>
        <ActivityConnectedForm
          close={this.props.close}
          onSave={this.props.onSave}
          id={this.props.id}
          timesheetId={this.props.timesheetId}
        />
      </Modal>)
    );
  }
}

export default ActivityModalForm;
